export default __webpack_public_path__ + "img/stage1.29d3735b.png";